module.exports = __webpack_public_path__ + "static/media/Grøt-min.0adc6a76.PNG";